
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":".121","width":"18","height":"18","rx":"4","fill":"#EBEBEB"}}),_c('path',{attrs:{"d":"M9.13 14.033c-.326 0-.56-.168-.7-.504L4.58 4.723c-.102-.234-.098-.416.014-.546a.56.56 0 01.462-.21c.168 0 .294.042.378.126a.863.863 0 01.238.336l3.472 8.05 3.458-8.064a.863.863 0 01.238-.336c.094-.075.224-.112.392-.112.196 0 .34.074.434.224.093.14.093.317 0 .532l-3.85 8.806a1.006 1.006 0 01-.266.378c-.102.084-.242.126-.42.126z","fill":"#000"}})])
          )
        }
      }
    